import React, { useState } from "react";
import { X } from "lucide-react";
import { getStatusClass } from "../Layout/StatusStyle";
import EditDetail from "./EditDetail";

const DetailBox = ({ handleClose, selectedObject, editIconVisibility }) => {
  const [openEditBox, setOpenEditBox] = useState(false);
  const handleEdit = () => {
    setOpenEditBox(true);
  };
  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        onClick={handleClose}
      >
        <div
          className="bg-white rounded-[20px] w-[85vw] sm:w-[80vw] max-h-[90vh] p-6 relative flex flex-col max-w-[800px]"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="">
            <button
              onClick={handleClose}
              className="absolute -top-6 sm:-right-8 -right-5 bg-white rounded-full p-1 sm:p-2  shadow-md"
            >
              <X className="w-5 h-5 text-gray-600 hover:text-gray-800" />
            </button>
          </div>
          <div>
            <div className="flex justify-between">
              <h2 className="sm:text-3xl text-2xl font-bold mb-3 text-text1">
                Detail info
              </h2>
              {/* {editIconVisibility && (
                <div>
                  <button
                    className="text-white text-sm bg-primary px-4 py-3 rounded-md"
                    onClick={handleEdit}
                  >
                    Edit
                  </button>
                </div>
              )} */}
            </div>
            <hr className="mt-4" />
          </div>
          <div className="mb-3">
            <div className="flex justify-between pt-3 pb-2.5">
              <p className="font-medium sm:text-base text-sm text-text1">
                Patient details
              </p>
            </div>
            {[
              { label: "Patient name", value: selectedObject.patientname },
              { label: "Patient email", value: selectedObject.patientemail },
              {
                label: "Mobile Number",
                value: selectedObject.patientnumber,
              },
            ].map(({ label, value }) => (
              <div key={label} className="flex justify-between py-3 gap-2">
                <p className="font-medium sm:text-base text-sm text-text3">
                  {label}
                </p>
                <p className="font-medium sm:text-base text-sm text-text1 text-right">
                  {value || ""}
                </p>
              </div>
            ))}
          </div>
          <hr />
          <div className="mb-3">
            <div className="flex justify-between pt-3 pb-2.5 ">
              <p className="font-medium sm:text-base text-sm text-text1">
                Product details
              </p>
            </div>
            {[
              { label: "Doctor name", value: selectedObject.doctorsname },
              { label: "Product code", value: selectedObject.product_id },
              {
                label: "Product name",
                value: selectedObject.product_code,
              },
              {
                label: "Quantity",
                value: selectedObject.quantity,
              },
              {
                label: "Status",
                value: selectedObject.tracking_status,
              },
            ].map(({ label, value }) => (
              <div key={label} className="flex justify-between py-3 gap-2">
                <p className="font-medium sm:text-base text-sm text-text3 ">
                  {label}
                </p>
                <p className="font-medium sm:text-base text-sm text-text1 text-right">
                  {label === "Status" ? (
                    <span className={getStatusClass(value)}>{value} </span>
                  ) : (
                    value || ""
                  )}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {openEditBox && <EditDetail closeModal={() => setOpenEditBox(false)} />}
    </>
  );
};

export default DetailBox;
